import React, { useEffect, useRef } from "react";
import { Form, Row, Col, Button as AntdButton, Typography } from "antd";
import { Button } from "components/Buttons/Buttons";
import Modal from "components/Modal/Modal";
import { useForm } from "antd/lib/form/Form";
import {
  FormHiddenSubmitButton,
  FormInputArea,
} from "components/FormItems/FlatFormItems";
import { useDispatch } from "react-redux";
import {
  updateConfigByKey,
  getConfigByKey,
} from "services/misc.service";

const { Text, Title } = Typography;

function TermsAndConditionsModal({ visible, onCancel }) {
  const dispatch = useDispatch();
  const [form] = useForm();
  const submitBtnRef = useRef();

  useEffect(() => {
    loadTermsAndConditions("TAndC");
  }, []);

  const loadTermsAndConditions = async (ckey = "") => {
    const result = await dispatch(getConfigByKey(ckey));
    if (result?.status === "success") {
      form.setFieldsValue({
        TAndC: result.data.value,
      });
    }
  };

  return (
    <Modal
      //   closable={closable}
      destroyOnClose={true}
      //   headerBorder={false}
      width="720px"
      className="cancellationPolicyModal"
      title={`Terms and Conditions`}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      visible={visible}
      onOk={() => console.log("ok")}
      okText="Add"
      centered={true}
      footer={
        <div className="d-flex justify-between align-center">
          <AntdButton
            type="text"
            onClick={() => {
              onCancel();
              form.resetFields();
            }}
          >
            Cancel
          </AntdButton>
          <Button
            style={{ height: 50 }}
            rounded={true}
            //   disabled={!Boolean(setupIntent)}
            onClick={() => submitBtnRef?.current?.click()}
          >
            Save
          </Button>
        </div>
      }
      //   cancelText="No"
    >
      <Form
        form={form}
        initialValues={{}}
        layout="vertical"
        requiredMark={false}
        onFinish={(values) => {
          // add cancellation policy
          dispatch(updateConfigByKey("TAndC", values.TAndC)).then(
            (result) => {
              if (result?.status === "success") {
                form.resetFields();
                onCancel();
              }
            }
          );
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <FormInputArea
              label="Cancellation Terms and Conditions"
              required={true}
              name={"TAndC"}
              variant="underlined"
              formItemStyles={{ width: "100%" }}
              // initialValue={notes[0] ? notes[0].noteDescription : ''}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <FormHiddenSubmitButton submitRef={submitBtnRef} />
        </Row>
      </Form>
    </Modal>
  );
}

TermsAndConditionsModal.propTypes = {};

export default TermsAndConditionsModal;
